import AmenityGroup from "@CheckOrder/features/amenities/components/AmenityGroup";
import useDialog from "@Features/dialog/hooks/useDialog";
import AmenityErrorModal from "@CheckOrder/features/amenities/components/AmenityErrorModal";
import usePairSingleAndReturnAmenityGroups
    from "@CheckOrder/features/amenities/hooks/usePairSingleAndReturnAmenityGroups";
import {AmenitiesType} from "@CheckOrder/features/amenities/types/Amenities.type";

interface AmenityGroupProps {
    amenities: AmenitiesType
}

function AmenityGroups({amenities}: AmenityGroupProps) {
    const {
        dialogRef,
        openModal: openErrorModal,
    } = useDialog()

    const {
        pairedSingleAndReturnAmenities,
    } = usePairSingleAndReturnAmenityGroups(amenities)

    return (
        <>
            {Object.entries(pairedSingleAndReturnAmenities).map(([groupKey, pairedAmenityGroups]) => (
                <AmenityGroup
                    key={groupKey}
                    pairedAmenityGroups={pairedAmenityGroups}
                    openErrorModal={openErrorModal}
                    groupKey={groupKey}
                />
            ))}
            <AmenityErrorModal
                errorDialogRef={dialogRef}
            />
        </>
    );
}

export default AmenityGroups